<template>
  <v-card>
    <v-card-text style="padding-bottom:0;">
      <v-layout row justify-center>
        <v-flex xs5>
          <v-radio-group v-model="radioGroup" @change="$emit('resetForm')">
            <v-radio color="black" label="วันหยุด 1 วัน" value="0"></v-radio>
            <v-radio color="black" label="วันหยุด 1 ช่วง" value="1"></v-radio>
            <v-radio
              color="black"
              label="หยุดวันที่..ของเดือน"
              value="2"
            ></v-radio>
            <v-radio
              color="black"
              label="หยุดทุกวัน..ที่..ของเดือน"
              value="3"
            ></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs6>
          <v-form ref="form" v-model="valid">
            <section id="sec01" v-if="radioGroup == '0'">
              <v-menu
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="-30"
                lazy
                transition="scale-transition"
                offset-y
              >
                <v-text-field
                  slot="activator"
                  v-model="form.store_close_date"
                  label="Select close date"
                  prepend-icon="event"
                  :rules="[rules.required]"
                  readonly
                ></v-text-field>
                <v-date-picker
                  :min="moment().format('YYYY-MM-DD')"
                  color="#333"
                  no-title
                  v-model="form.store_close_date"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
              <v-flex xs12 class="d-flex justify-space-around">
                <!-- <v-icon>access_time</v-icon>
              <vue-timepicker ยังไม่ถึงเวอร์ชั่นต้องใส่เวลา
                :format="'HH:mm'"
                :minute-interval="15"
                class="timePicker newinner1-timePicker"
                ></vue-timepicker>-->
              </v-flex>
              <v-textarea
                v-model="form.store_close_note"
                solo
                rows="3"
                label="Note:"
                class="my-3"
              ></v-textarea>
            </section>
            <section id="sec02" v-if="radioGroup == '1'">
              <v-menu
                :close-on-content-click="false"
                v-model="menu2start"
                :nudge-right="-30"
                lazy
                transition="scale-transition"
                offset-y
              >
                <v-text-field
                  slot="activator"
                  v-model="form.store_close_date_start"
                  label="Start close date"
                  prepend-icon="event"
                  :rules="[rules.required]"
                  readonly
                ></v-text-field>
                <v-date-picker
                  :min="moment().format('YYYY-MM-DD')"
                  color="#333"
                  no-title
                  v-model="form.store_close_date_start"
                  @input="menu2start = false"
                ></v-date-picker>
              </v-menu>
              <v-flex xs12 class="d-flex justify-space-around">
                <!-- <v-icon>access_time</v-icon>  ยังไม่ถึงเวอร์ชั่นต้องใส่เวลา
              <vue-timepicker
                :format="'HH:mm'"
                :minute-interval="15"
                class="timePicker newinner1-timePicker"
                ></vue-timepicker>-->
              </v-flex>
              <v-menu
                :close-on-content-click="false"
                v-model="menu2end"
                :nudge-right="-30"
                lazy
                transition="scale-transition"
                offset-y
              >
                <v-text-field
                  slot="activator"
                  v-model="form.store_close_date_end"
                  label="End close date"
                  prepend-icon="event"
                  :rules="[rules.required]"
                  readonly
                ></v-text-field>
                <v-date-picker
                  :min="moment().format('YYYY-MM-DD')"
                  color="#333"
                  no-title
                  v-model="form.store_close_date_end"
                  @input="menu2end = false"
                ></v-date-picker>
              </v-menu>
              <v-flex xs12 class="d-flex justify-space-around">
                <!-- <v-icon>access_time</v-icon> ยังไม่ถึงเวอร์ชั่นต้องใส่เวลา
              <vue-timepicker
                :format="'HH:mm'"
                :minute-interval="15"
                class="timePicker newinner1-timePicker"
                ></vue-timepicker>-->
              </v-flex>
              <v-textarea
                v-model="form.store_close_note"
                solo
                rows="3"
                label="Note:"
                class="my-3"
              ></v-textarea>
            </section>
            <section id="sec03" v-if="radioGroup == '2'">
              <v-layout row>
                <v-flex xs5>
                  <v-subheader
                    v-text="'หยุดทุกวันที่..'"
                    style="padding-top:24px; padding-left:0;"
                  ></v-subheader>
                </v-flex>
                <v-flex xs7>
                  <v-select
                    :items="number3"
                    v-model="form.store_close_period"
                    menu-props="auto"
                    label="Select date"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-flex xs12 class="d-flex justify-space-around">
                <!-- <v-subheader v-text="'เวลา..'" style="padding-top:12px; padding-left:0;"></v-subheader> -->
                <!-- <vue-timepicker ยังไม่ถึงเวอร์ชั่นต้องใส่เวลา
                :format="'HH:mm'"
                :minute-interval="15"
                class="timePicker newinner2-timePicker"
                ></vue-timepicker>-->
              </v-flex>
              <v-textarea
                v-model="form.store_close_note"
                solo
                rows="3"
                label="Note:"
                class="my-3"
              ></v-textarea>
            </section>
            <section id="sec04" v-if="radioGroup == '3'">
              <v-layout row>
                <v-flex xs5>
                  <v-subheader
                    v-text="'หยุดทุกวัน..'"
                    style="padding-top:24px; padding-left:0;"
                  ></v-subheader>
                </v-flex>
                <v-flex xs7>
                  <v-select
                    :items="days"
                    v-model="form.store_close_pattern_weekday"
                    menu-props="auto"
                    label="Select day"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs5>
                  <v-subheader
                    v-text="'ที่..'"
                    style="padding-top:24px; padding-left:0;"
                  ></v-subheader>
                </v-flex>
                <v-flex xs7>
                  <v-select
                    :items="number4"
                    v-model="form.store_close_pattern_weeknum"
                    menu-props="auto"
                    label="Select date"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-flex xs12 class="d-flex justify-space-around">
                <!-- <v-subheader v-text="'เวลา..'" style="padding-top:12px; padding-left:0;"></v-subheader> -->
                <!-- <vue-timepicker ยังไม่ถึงเวอร์ชั่นต้องใส่เวลา
                :format="'HH:mm'"
                :minute-interval="15"
                class="timePicker newinner2-timePicker"
                ></vue-timepicker>-->
              </v-flex>
              <v-textarea
                v-model="form.store_close_note"
                solo
                rows="3"
                label="Note:"
                class="my-3"
              ></v-textarea>
            </section>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions style="padding-top:0;">
      <v-spacer />
      <v-btn flat color="red" @click="$emit('cancel')">Cancel</v-btn>
      <v-btn
        depressed
        color="green"
        :disabled="loading || isEditStoreList"
        :loading="loading"
        @click="save()"
        >add</v-btn
      >
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { mapGetters } from "vuex";
export default {
  props: ["form", "store_add_id"],
  data() {
    return {
      rules: {
        required: (value) => !!value || "Required.",
      },
      valid: true,
      radioGroup: "0",
      menu1: false,
      menu2start: false,
      menu2end: false,
      number3: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
      number4: [1, 2, 3, 4, 5],
      days: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      loading: false,
    };
  },
  components: {
    VueTimepicker,
  },
  computed: {
    ...mapGetters(["isEditStoreList"]),
  },
  methods: {
    async save() {
      if (this.$refs.form.validate()) {
        if (this.radioGroup == "0") {
          this.form.store_close_type = "day";
        } else if (this.radioGroup == "1") {
          this.form.store_close_type = "start_end";
        } else if (this.radioGroup == "2") {
          this.form.store_close_type = "period";
        } else {
          this.form.store_close_type = "pattern";
        }
        this.loading = true;
        let obj_clone = JSON.parse(JSON.stringify(this.form));
        obj_clone.store_close_store_id = this.store_add_id;
        await this.$store.dispatch("fetchStoreBack/addSpecialTime", obj_clone);
        this.loading = false;
        this.$emit("cancel");
        this.$emit("save");
      }
    },
  },
};
</script>

<style>
.newinner1-timePicker {
  border-bottom: 1px solid #808080;
  width: 10em;
  left: -10px;
  padding-right: 45px;
}
.newinner2-timePicker {
  border-bottom: 1px solid #808080;
  width: 50%;
  left: 10px;
  padding-right: 15px;
  margin-right: 5px;
}
</style>
